import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-24 px-4 md:px-8 lg:px-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide uppercase mb-4">
            Categorias
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-950 font-heading mb-4">
            Explore por Categoria
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto">
            Navegue pelas categorias organizadas do{" "}
            <strong>hoobuyspreadsheet</strong> e encontre exatamente o que você
            procura com os melhores preços.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-white rounded-2xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative w-full h-[220px] overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} - ${cat.namePt} hoobuy spreadsheet categoria`}
                  title={`${cat.name} | Hoobuy Spreadsheet ${cat.namePt}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/8 to-transparent"></div>
                {cat.tag && (
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-secondary-500 text-white text-[11px] font-semibold rounded-full z-10">
                    {cat.tag}
                  </span>
                )}
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-base font-bold text-white font-heading mb-0.5 leading-snug">
                    {cat.name}
                  </h3>
                  <p className="text-white/70 text-xs flex items-center gap-1">
                    {cat.namePt}
                    <i className="ri-arrow-right-up-line text-[10px]"></i>
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}